import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-735490b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resourcesBox" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "主账号剩余资源", -1))
const _hoisted_3 = { class: "MasterBox" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { style: {"background":"#f5f7fa","padding-top":"15px"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "子账号剩余资源", -1))
const _hoisted_7 = { class: "SubBox" }
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "StepperBox" }
const _hoisted_10 = { class: "buttonBox" }

import { ref, nextTick } from 'vue';
import * as echarts from 'echarts';
import http from '@/api/subordinate';
import { getToken } from '@/plugins/cookie';
import { Button, message } from 'ant-design-vue';
import SvgIcon from '@/components/SvgIcon.vue';
import { useDebounce } from '@/hooks/useDebounce';


export default /*#__PURE__*/_defineComponent({
  __name: 'resources',
  props: {
    data: null
  },
  setup(__props: any, { expose }) {

const props = __props as { data: { id: number } };

const aButton = Button;
const token = getToken();
//主账号资源列表
const echarsList = ref([
  {
    balance: '',
    name: '',
  },
]);
//修改子账号资源
const SubaccountList = ref([
  {
    value: '',
    name: '',
    resources: '',
    status: '',
    key: '',
    number: 100,
    company: '',
  },
]);
// onMounted(() => {
//直播观看并发(中国内地)
const pieEchars = ref(`pieChart${Date.now() + Math.random()}`);
const getSetOption = (res: any) => {
  const data = [
    {
      value: res.used,
      itemStyle: {
        color: '#F0F2F5',
      },
      name: '使用',
    },
    {
      value: res.balance,
      itemStyle: {
        color: '#00ccb0',
      },
      emphasis: {
        itemStyle: {
          color: '#00ccb0',
        },
      },
      name: '剩余',
    },
  ];
  res.used == 0 ? data.splice(0, 1) : '';
  const setOption = {
    title: {
      text: res.balance + res.company,
      x: 'center',
      y: 'center',
      textStyle: {
        fontSize: '10',
        color: '#9AA1A9',
      },
    },
    tooltip: {
      //不能删
      // trigger: '并发数',
    },
    legend: {
      show: false, //隐藏名称
    },
    series: [
      {
        type: 'pie',
        radius: ['60%', '90%'],
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        data: data,
      },
    ],
  };
  return setOption;
};
const subpieEchars = ref(`pieChart${Date.now() + Math.random()}`);
const getSetOptions = (res: any) => {
  const data = [
    {
      value: res.value,
      itemStyle: {
        color: '#00ccb0',
      },
      name: '剩余',
    },
  ];
  res.value == 0 ? data.splice(0, 1) : '';
  const setOption = {
    title: {
      text: res.value + res.company,
      x: 'center',
      y: 'center',
      textStyle: {
        fontSize: '10',
        color: '#9AA1A9',
      },
    },
    tooltip: {
      //不能删
      // trigger: '并发数',
    },
    legend: {
      show: false, //隐藏名称
    },
    series: [
      {
        type: 'pie',
        radius: ['60%', '90%'],
        label: {
          show: false,
        },
        labelLine: {
          show: false,
        },
        data: data,
      },
    ],
  };
  return setOption;
};

// 分配资源--主账号资源
const getAccountInfo = () => {
  http.allAccountInfo().then((res) => {
    const data = res.data.data;
    echarsList.value = [...data.pack];
    // echarsList.value.splice(4);
    echarsList.value.map((res: any, index: number) => {
      res.resource_package.map((item: any) => {
        item.status = item.status == 0 ? '正常' : item.status == 1 ? '使用完' : item.status == 2 ? '已过期' : '未生效';
      });
      nextTick(() => {
        const pieChartsId = document.getElementById(pieEchars.value + index) as HTMLElement;
        const pieChartsSet = echarts.init(pieChartsId);
        pieChartsSet.setOption(getSetOption(res));
      });
    });
  });
};

// 分配资源--子账号资源
const subFormData = ref<any>({});
const getSubAccountInfo = () => {
  let data = {
    token: token,
    subordinate_id: props.data.id,
  };
  http
    .getSubordinateAccountResources({ params: data })
    .then((res) => {
      const data = res.data.data;
      SubaccountList.value = [...data];
      subFormData.value = SubaccountList.value.reduce((acc, cur) => {
        acc[cur.key] = 0;
        return acc;
      }, {} as any);
      SubaccountList.value.forEach((res: any, index: number) => {
        nextTick(() => {
          const pieChartsId = document.getElementById(subpieEchars.value + index) as HTMLElement;
          const pieChartsSet = echarts.init(pieChartsId);
          pieChartsSet.setOption(getSetOptions(res));
        });
      });
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
const resourcesStatus = ref<number[]>([]);
const resourcescolor = ref<boolean>(false);
//减少事件
const decline = (item: any, index: any) => {
  const itemNum = ref<number>(0);
  // itemNum.value = item.value;
  itemNum.value = Math.ceil(item.value);
  let subNumberData = Number(SubaccountList.value[index].resources);
  if (itemNum.value == 0 && item.resources <= 0) {
    message.info('不能超过子账号资源');
    return;
  }
  if (itemNum.value.toString().length <= 2) {
    subNumberData -= 10;
  }
  if (itemNum.value.toString().length == 3) {
    subNumberData -= 100;
  }
  if (itemNum.value.toString().length == 4) {
    subNumberData -= 1000;
  }
  if (itemNum.value.toString().length == 5) {
    subNumberData -= 10000;
  }
  subFormData.value[SubaccountList.value[index].key] = SubaccountList.value[index].resources = subNumberData.toString();
  resourcesStatus[index] = 0;
  isresources.value = true;
  resourcescolor[index] = false;
};
const increase = (item: any, index: any) => {
  const itemNum = ref<number>(0);
  let subNumberData = Number(SubaccountList.value[index].resources);
  // itemNum.value = item.value;
  itemNum.value = Math.ceil(item.value);
  if (itemNum.value.toString().length <= 2) {
    subNumberData += 10;
  }
  if (itemNum.value.toString().length == 3) {
    subNumberData += 100;
  }
  if (itemNum.value.toString().length == 4) {
    subNumberData += 1000;
  }
  if (itemNum.value.toString().length == 5) {
    subNumberData += 10000;
  }
  subFormData.value[SubaccountList.value[index].key] = SubaccountList.value[index].resources = subNumberData.toString();
  resourcesStatus[index] = 1;
  isresources.value = true;
  resourcescolor[index] = true;
};
const formatNum = useDebounce((index: number) => {
  const str = SubaccountList.value[index].resources[0] === '-' ? '-' : '';
  const newVal = str + SubaccountList.value[index].resources.replace(/\D/g, '');
  SubaccountList.value[index].resources = newVal;
  subFormData.value[SubaccountList.value[index].key] = parseInt(newVal, 10);
});

//分配资源
const isresources = ref<boolean>(false);
const resourcesHandleOk = useDebounce(() => {
  const createRes = echarsList.value.some((item, index) => {
    const val = Number(SubaccountList.value[index].resources);
    return Number(item.balance) < val && val > 0;
  });
  if (createRes) {
    message.info('不能超过主账号资源');
    return;
  }
  const delRes = SubaccountList.value.some((item) => {
    console.log(item.resources);
    const val = Number(item.resources);
    return val < 0 && Math.abs(val) > Number(item.value);
  });
  if (delRes) {
    message.info('不能超过子账号资源');
    return;
  }
  const subdata = {
    id: props.data.id,
    ...subFormData.value,
  };
  http
    .adminSubAllocatingResources(subdata)
    .then((res) => {
      message.success(res.data.message);
      getAccountInfo();
      getSubAccountInfo();
      // isresources.value = false;
    })
    .catch((res) => {
      message.error(res.data.error);
    });
});
expose({ getSubAccountInfo, getAccountInfo });

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(echarsList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "MasterItem"
        }, [
          _createElementVNode("p", null, _toDisplayString(item.name), 1),
          _createElementVNode("div", {
            id: pieEchars.value + index,
            class: "echartBox"
          }, null, 8, _hoisted_4)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(SubaccountList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "MasterItem"
          }, [
            _createElementVNode("p", null, _toDisplayString(item.name), 1),
            _createElementVNode("div", {
              id: subpieEchars.value + index,
              class: "echartBox"
            }, null, 8, _hoisted_8),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(SvgIcon, {
                "icon-class": "resourcesReduce",
                class: "iconBox",
                onClick: ($event: any) => (decline(item, index))
              }, null, 8, ["onClick"]),
              _createElementVNode("span", null, [
                _createVNode(_component_a_input, {
                  value: item.resources,
                  "onUpdate:value": ($event: any) => ((item.resources) = $event),
                  onKeyup: ($event: any) => (_unref(formatNum)(index)),
                  placeholder: "0"
                }, null, 8, ["value", "onUpdate:value", "onKeyup"]),
                _createTextVNode(_toDisplayString(item.company), 1)
              ]),
              _createVNode(SvgIcon, {
                "icon-class": "resourcesAdd",
                class: "iconBox",
                onClick: ($event: any) => (increase(item, index))
              }, null, 8, ["onClick"])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_unref(aButton), {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(resourcesHandleOk)()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})